export default __webpack_public_path__ + "static/media/offer-icon-private.4db9ffc8.svg";